// Paul Gagliardi Photography theme JS

document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  // ---------- Scroll-reveal ----------
  const revealTargets = document.querySelectorAll(
    '.product-tile, .photo-card:not(.product-tile__media), .tile, .tiles__head, .collection-head, .about-strip blockquote'
  );
  if (revealTargets.length && 'IntersectionObserver' in window) {
    revealTargets.forEach((el, i) => {
      el.classList.add('reveal');
      // Gentle stagger within each viewport batch
      el.style.transitionDelay = `${(i % 3) * 90}ms`;
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealTargets.forEach((el) => io.observe(el));
  }
  // ---------- Image protection (deterrent only) ----------
  document.addEventListener('contextmenu', (e) => {
    if (e.target.closest('.photo-card, .lightbox, .hero__media, .tile, .product__media')) {
      e.preventDefault();
    }
  });
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') e.preventDefault();
  });

  // ---------- Image load fade-in ----------
  document.querySelectorAll('.photo-card img, .tile img').forEach((img) => {
    if (img.complete && img.naturalWidth) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
      img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
    }
  });

  // ---------- Lightbox ----------
  const lbLinks = Array.from(document.querySelectorAll('[data-lightbox]'));
  if (lbLinks.length) {
    const overlay = document.createElement('div');
    overlay.className = 'lightbox';
    overlay.innerHTML = `
      <button class="lightbox__close" aria-label="Close">&times;</button>
      <button class="lightbox__nav lightbox__nav--prev" aria-label="Previous">&#8592;</button>
      <figure class="lightbox__figure">
        <img class="lightbox__img" alt="">
        <figcaption class="lightbox__caption"></figcaption>
        <div class="lightbox__products"></div>
        <span class="lightbox__count"></span>
      </figure>
      <button class="lightbox__nav lightbox__nav--next" aria-label="Next">&#8594;</button>
    `;
    document.body.appendChild(overlay);

    const img = overlay.querySelector('.lightbox__img');
    const caption = overlay.querySelector('.lightbox__caption');
    const count = overlay.querySelector('.lightbox__count');
    const products = overlay.querySelector('.lightbox__products');
    let current = 0;

    const preload = (i) => {
      const link = lbLinks[(i + lbLinks.length) % lbLinks.length];
      new Image().src = link.href;
    };

    const show = (i) => {
      current = (i + lbLinks.length) % lbLinks.length;
      const link = lbLinks[current];
      img.src = link.href;
      img.alt = link.dataset.title || '';
      caption.textContent = link.dataset.title || '';
      count.textContent = `${current + 1} / ${lbLinks.length}`;
      products.innerHTML = '';
      (link.dataset.products || '').split('~~').filter(Boolean).forEach((entry) => {
        const [label, url, price] = entry.split('|');
        if (!url) return;
        const a = document.createElement('a');
        a.href = url;
        a.className = 'lightbox__product';
        a.innerHTML = `${label} &middot; from ${price} <span aria-hidden="true">&rarr;</span>`;
        products.appendChild(a);
      });
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      preload(current + 1);
      preload(current - 1);
    };
    const close = () => {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    };

    lbLinks.forEach((link, i) => {
      link.addEventListener('click', (e) => { e.preventDefault(); show(i); });
    });
    overlay.querySelector('.lightbox__close').addEventListener('click', close);
    overlay.querySelector('.lightbox__nav--prev').addEventListener('click', (e) => { e.stopPropagation(); show(current - 1); });
    overlay.querySelector('.lightbox__nav--next').addEventListener('click', (e) => { e.stopPropagation(); show(current + 1); });
    overlay.addEventListener('click', (e) => { if (e.target === overlay || e.target.classList.contains('lightbox__figure')) close(); });
    document.addEventListener('keydown', (e) => {
      if (!overlay.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });

    // Touch swipe navigation
    let touchX = null;
    overlay.addEventListener('touchstart', (e) => { touchX = e.changedTouches[0].clientX; }, { passive: true });
    overlay.addEventListener('touchend', (e) => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 48) show(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  // Product page: thumbnail switching
  const mainImg = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImg) return;
      mainImg.src = thumb.dataset.full;
      mainImg.srcset = '';
      document.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // Product page: variant price update
  const variantSelect = document.querySelector('[data-variant-select]');
  const priceEl = document.querySelector('[data-price]');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', () => {
      const opt = variantSelect.selectedOptions[0];
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      const btn = document.querySelector('[data-add-btn]');
      if (btn) {
        const available = opt.dataset.available === 'true';
        btn.disabled = !available;
        btn.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldOut;
      }
    });
  }

  // AJAX add to cart
  const form = document.querySelector('[data-product-form]');
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-btn]');
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: form.querySelector('[name="id"]').value,
            quantity: 1,
          }),
        });
        if (!res.ok) throw new Error('add failed');
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const count = document.querySelector('[data-cart-count]');
        if (count) count.textContent = cart.item_count;
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1600);
      } catch (err) {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      }
    });
  }
});
